import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-8" style={{background: 'linear-gradient(135deg, #f0fdfa 0%, #fef2f2 100%)'}}>
          <div className="max-w-lg w-full bg-white rounded-xl shadow-lg p-8 border border-red-200">
            <h2 className="text-xl font-bold text-red-700 mb-2">Something went wrong</h2>
            <p className="text-gray-600 mb-4">
              This page encountered an error while loading. Try refreshing the page or clearing your browser cache.
            </p>
            <details className="mb-4 text-sm">
              <summary className="cursor-pointer text-gray-500 hover:text-gray-700 font-medium">
                Technical details
              </summary>
              <pre className="mt-2 p-3 bg-gray-50 rounded-lg text-xs text-red-600 overflow-x-auto whitespace-pre-wrap break-words">
                {this.state.error?.toString()}
                {this.state.errorInfo?.componentStack}
              </pre>
            </details>
            <div className="flex gap-3">
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 rounded-lg text-white text-sm font-medium"
                style={{ backgroundColor: '#157a6e' }}
              >
                Refresh Page
              </button>
              <button
                onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
                className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50"
              >
                Try Again
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
